import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

// Who a questionnaire is with. Deliberately NOT AssigneeFilterDropdown, which
// lists the account's users: a questionnaire's assignee may be a vendor contact
// with no user record here at all, so the options come from the rows on screen.
export const QuestionnaireAssigneeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <GenericFilterDropdown
      filterParam={FilterParam.QUESTIONNAIRE_ASSIGNEE}
      filterName={FilterName.QUESTIONNAIRE_ASSIGNEE}
      valueKey="questionnaireAssignees"
      isNested={isNested}
    />
  ),
)
